import {connect} from "react-redux";
import V2OpportunityActivityList from "./List";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {getOpportunity} from "../../../../service/Opportunities/action";
import {isUserCheckInForModule} from "../../../../service/Account/action";
import {markAttendance} from "../../../../service/DCC/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {accountDetailsById} from "../../../../service/Account/action";
import {ratingSave} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    activityListDetails:state.Activity.activityList,
    opportunityDetails:state.Opportunitie.opportunityDetails,
    userCheckInForModule:state.Dropdown.userCheckInForModule,
    attendance:state.DCC.attendance,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    accountDetails:state.Dropdown.accountDetailsById,
    savedRating: state.Dealer.savedRating
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            getOpportunity,
            isUserCheckInForModule,
            markAttendance,
            documentUploadUrlPublic,
            accountDetailsById,
            ratingSave,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(V2OpportunityActivityList);
